module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/diseases/lung_class-1a28e455e87239124fe568bd5c9e7874.png";